import { LegacyDocumentType } from '@commenda/prisma';

export const documentName = (t: LegacyDocumentType | undefined): string => {
  const record: Record<LegacyDocumentType, string> = {
    [LegacyDocumentType.AnnualAccountsApprovalMinutes]: 'Annual Accounts Approval Minutes',
    [LegacyDocumentType.AnnualAccountsNotes]: 'Annual Accounts Notes',
    [LegacyDocumentType.AnnualAccountsPublication]: 'Annual Accounts Legal Publication',
    [LegacyDocumentType.CaboVerdeModelo109]: 'Modelo 109 Taxpayer Register Enrollment Declaration',
    [LegacyDocumentType.CaboVerdeModelo110]: 'Modelo 110 VAT Activity Declaration',
    [LegacyDocumentType.CapitalAvailabilityAndDepositDeclaration]: 'Capital Availability and Two-Business-Day Deposit Declaration',
    [LegacyDocumentType.CommercialRegistrationApplication]: 'Commercial Registration Application',
    [LegacyDocumentType.ConsolidatedAccountsApprovalMinutes]: 'Consolidated Accounts Approval Minutes',
    [LegacyDocumentType.ConsolidatedAccountsNotes]: 'Consolidated Accounts Notes',
    [LegacyDocumentType.ConsolidatedBalanceSheet]: 'Consolidated Balance Sheet',
    [LegacyDocumentType.ConsolidatedIncomeStatement]: 'Consolidated Income Statement',
    [LegacyDocumentType.ConstitutiveActCertificate]: 'Certificate of Constitutive Act',
    [LegacyDocumentType.ConstitutiveAssemblyMinutes]: 'Constitutive Assembly Minutes',
    [LegacyDocumentType.FiscalOversightOpinion]: 'Fiscal Oversight Body Opinion',
    [LegacyDocumentType.InKindContributionValuationReport]: 'In-Kind Contribution Valuation Report',
    [LegacyDocumentType.InpsContributorRegistrationForm]: 'Contributor Registration Bulletin',
    [LegacyDocumentType.LegalCertificationOfAccounts]: 'Legal Certification of Accounts',
    [LegacyDocumentType.LegalCertificationOfConsolidatedAccounts]: 'Legal Certification of Consolidated Accounts',
    [LegacyDocumentType.LegalRepresentativeDeclaration]: 'Legal Representative Declaration',
    [LegacyDocumentType.PermissionOfIncorporation]: 'Permission of Incorporation',
    [LegacyDocumentType.PublicSubscriptionCompanyContractProject]: 'Public-Subscription Company Contract Project',
    [LegacyDocumentType.PublicSubscriptionOfferAnnouncement]: 'Public-Subscription Share Offer Announcement',
    [LegacyDocumentType.PublicSubscriptionOrShareIssuanceAuthorization]: 'Public-Subscription or Share-Issuance Authorization',
    [LegacyDocumentType.RempeCertificate]: 'REMPE Certificate',
    [LegacyDocumentType.RempeIdentificationCard]: 'REMPE Identification Card',
    [LegacyDocumentType.TaxpayerCard]: 'Taxpayer Card',
    [LegacyDocumentType.InvalidDefaultValue]: '',
    [LegacyDocumentType.ArticlesOfAssociation]: 'Articles of Association',
    [LegacyDocumentType.CommencementOfBusiness]: 'Commencement of Business',
    [LegacyDocumentType.CommencementOfBusinessSigned]:
      'Commencement of Business Signed',
    [LegacyDocumentType.UnsignedCommencementOfBusiness]:
      'Unsigned Commencement of Business',
    [LegacyDocumentType.ActionBySoleIncorporator]:
      'Action of Sole Incorporator',
    [LegacyDocumentType.BylawsUnsigned]: 'Company Bylaws Unsigned',
    [LegacyDocumentType.Bylaws]: 'Company Bylaws',
    [LegacyDocumentType.OperatingAgreement]: 'Operating Agreement',
    [LegacyDocumentType.EIN]: 'EIN',
    [LegacyDocumentType.formationDocument]: 'Company Formation Document',
    [LegacyDocumentType.CertificateOfIncorporation]:
      'Certificate of Incorporation',
    [LegacyDocumentType.CertificateOfIncorporationByMCA]:
      'MCA Certificate of Incorporation',
    [LegacyDocumentType.CertificateOfAmendment]: 'Certificate of Amendment',
    [LegacyDocumentType.SalesTransactionDocument]: 'Sales Transaction Document',
    [LegacyDocumentType.SalesTaxProductCSV]: 'Sales Tax Product CSV',
    [LegacyDocumentType.SalesTaxCustomerCSV]: 'Sales Tax Customer CSV',
    [LegacyDocumentType.MemorandumOfAssociation]: 'Memorandum Of Association',
    [LegacyDocumentType.InitialBondApprovalCall]: 'Initial Board Approval Call',
    [LegacyDocumentType.CorporatePAN]: 'Corporation PAN Card',
    [LegacyDocumentType.LLPDeed]: 'Limited liability partnership(LLP) Deed',
    [LegacyDocumentType.LLCOperatingAgreement]: 'LLC Operating Agreement',
    [LegacyDocumentType.INC20A]: 'INC-20A',
    [LegacyDocumentType.GST_REGISTRATION_FORM]: 'GST Registration form',
    [LegacyDocumentType.CapTable]: 'Cap Table',
    [LegacyDocumentType.UnsignedSharePurchaseAndSaleAgreement]:
      'Unsigned Stock Purchase and Sale Agreement(s)',
    [LegacyDocumentType.SharePurchaseAndSaleAgreement]:
      'Stock Purchase and Sale Agreement(s)',
    [LegacyDocumentType.SharePurchaseAndSaleAgreementForCorporationPurchaser]:
      'Stock Purchase Agreement for Corporation Purchaser',
    [LegacyDocumentType.ShareCertificate]: 'Share Certificate',
    [LegacyDocumentType.StockPlansAndOptionAgreement]:
      'Stock Plans and Option Agreement(s)',
    [LegacyDocumentType.SS4]: 'SS-4',
    [LegacyDocumentType.NonDisclosureAgreement]: 'Non-Disclosure Agreements',
    [LegacyDocumentType.AddressProof]: 'Address Verification Proof',
    [LegacyDocumentType.PanCard]: 'Individual PAN Card',
    [LegacyDocumentType.TAN]: 'TAN',
    [LegacyDocumentType.AadharCard]: 'Aadhar Card',
    [LegacyDocumentType.GovernmentId]: 'Government Id Document(s)',
    [LegacyDocumentType.DigitalSignatureCertificate]:
      'Digital Signature Certificate',
    [LegacyDocumentType.AnnualAuditPreviousYear]: 'Annual Audit Previous Year',
    [LegacyDocumentType.Form9]: 'Form9',
    [LegacyDocumentType.SubscribersSheet]: "Subscriber's Sheet",
    [LegacyDocumentType.BalanceSheet]: 'Balance Sheet',
    [LegacyDocumentType.Invoices]: 'Invoices',
    [LegacyDocumentType.IncomeStatement]: 'Income Statement(s)',
    [LegacyDocumentType.CashFlowStatement]: 'Cash Flow Statement',
    [LegacyDocumentType.CashFlowStatements]: 'Cash Flow Statement(s)',
    [LegacyDocumentType.ProfitLossStatements]: 'Profit Loss Statements',
    [LegacyDocumentType.ExpenseDocuments]: 'Expense Documents',
    [LegacyDocumentType.BillDocuments]: 'Bill Documents',
    [LegacyDocumentType.YearlyFinancials]: 'Previous Yearly Financials',
    [LegacyDocumentType.BankStatements]: 'Bank Statements',
    [LegacyDocumentType.CardStatements]: 'Card Statements',
    [LegacyDocumentType.AnnualProfitLossStatement]:
      'Annual Profit Loss Statement',
    [LegacyDocumentType.SalesTaxInformation]: 'Sales Tax Information',
    [LegacyDocumentType.Form940]: 'Form 940',
    [LegacyDocumentType.Form941]: 'Form 941',
    [LegacyDocumentType.StatementOfCapital]: 'Statement of Capital',
    [LegacyDocumentType.AnnualGeneralMeetingReport]:
      'Annual General Meeting Report',
    [LegacyDocumentType.TaxReturnsFederal]: 'Federal Tax Returns',
    [LegacyDocumentType.TaxReturnsState]: 'State Tax Returns',
    [LegacyDocumentType.PayrollRecord]: 'Payroll Record',
    [LegacyDocumentType.BillForRegisteredAddress]:
      'Bill for Registered Address',
    [LegacyDocumentType.RentalAgreement]: 'Rental Agreement',
    [LegacyDocumentType.TDSReturns]: 'TDS Returns',
    [LegacyDocumentType.CP525]: 'CP525',
    [LegacyDocumentType.Form5472Acknowledgement]: 'Form 5472 Acknowledgement',
    [LegacyDocumentType.Form1099Acknowledgement]: 'Form 1099 Acknowledgement',
    [LegacyDocumentType.Form1120Acknowledgement]: 'Form 1120 Acknowledgement',
    [LegacyDocumentType.Form1120ExtensionAcknowledgement]:
      'Form 1120 Extension Acknowledgement',
    [LegacyDocumentType.FormW2Acknowledgement]: 'Form W2 Acknowledgement',
    [LegacyDocumentType.FBARAcknowledgement]: 'FBAR Filing Acknowledgement',
    [LegacyDocumentType.ComplianceAcknowledgement]:
      'Compliance Acknowledgement Document',
    [LegacyDocumentType.DelawareAnnualFranchiseTaxAcknowledgement]:
      'Delaware Annual Franchise Tax Acknowledgement',
    [LegacyDocumentType.Form5471Acknowledgement]: 'Form 5471 Acknowledgement',
    [LegacyDocumentType.SAFE]: 'SAFE Note',
    [LegacyDocumentType.ContractorAgreement]:
      'Independent Contractor Agreement',
    [LegacyDocumentType.PrivacyPolicy]: 'Privacy Policy',
    [LegacyDocumentType.UnsignedBoardConsent]: 'Unsigned Board Consent(s)',
    [LegacyDocumentType.BoardConsent]: 'Board Consent(s)',
    [LegacyDocumentType.Custom]: 'Custom Document',
    [LegacyDocumentType.Other]: 'Other',
    [LegacyDocumentType.Unknown]: 'Unknown',
    [LegacyDocumentType.GoodStandingCertificate]: 'Good Standing Certificate',
    [LegacyDocumentType.GSTRegistrationCertificate]:
      'GST Registration Certificate',
    [LegacyDocumentType.AntlerTermSheet]: 'Antler Term Sheet',
    [LegacyDocumentType.DueDiligenceDocument]: 'Due Diligence Document',
    [LegacyDocumentType.AntlerShareholdersRightsLetter]:
      'Antler Shareholders Rights Letter',
    [LegacyDocumentType.AntlerConditionsPrecedentCompletionCertificate]:
      'Antler Conditions Precedent Completion Certificate',
    [LegacyDocumentType.MonthlyMISReport]: 'Monthly Financial Report',
    [LegacyDocumentType.UnauditedFinancialStatements]:
      'Unaudited Financial Statements',
    [LegacyDocumentType.SalesTaxTransactionCSV]: 'Sales Tax Transaction CSV',
    [LegacyDocumentType.SalesTaxStateLiabilityReport]:
      'Sales Tax State Liability Report',
    [LegacyDocumentType.SalesTaxTransactionsFailureReport]:
      'Sales Tax Transactions Failure Report',
    [LegacyDocumentType.SpiceA]: 'SpiceA',
    [LegacyDocumentType.SpiceB]: 'SpiceB',
    [LegacyDocumentType.AgileForm]: 'Agile',
    [LegacyDocumentType.RunLLP]: 'Run LLP',
    [LegacyDocumentType.Fillip]: 'Fillip',
    [LegacyDocumentType.EINScreenshot]: 'EIN Proof',
    [LegacyDocumentType.UnsignedBoardResolution]: 'Unsigned Board Resolution',
    [LegacyDocumentType.BoardResolution]: 'Board Resolution',
    [LegacyDocumentType.IndPvtIncorporationDocument]:
      'India Private Limited Incorporation Documents',
    [LegacyDocumentType.SignedIndPvtIncorporationDocument]:
      'Signed India Private Limited Incorporation Documents',
    [LegacyDocumentType.UnsignedIndPvtIncorporationDocument]:
      'Unsigned India Private Limited Incorporation Documents',
    [LegacyDocumentType.IncorporationDocument]: 'Incorporation Documents',
    [LegacyDocumentType.SignedIncorporationDocument]:
      'Signed Incorporation Documents',
    [LegacyDocumentType.LLPSourceAndStampPaper]: 'LLP Source and Stamp Paper',
    [LegacyDocumentType.LLPSourceAndStampPaperSigned]:
      'LLP Source and Stamp Paper Signed',
    [LegacyDocumentType.UnsignedLLPSourceAndStampPaper]:
      'Unsigned LLP Source and Stamp Paper',
    [LegacyDocumentType.BankStatementsOfSubscriptionAmount]:
      'Bank Statement of Subscription Amount',
    [LegacyDocumentType.OfficePhotoWithNameBoard]:
      'Office Photo with the Name Board',
    [LegacyDocumentType.DirectorInOfficeProof]: 'Proof of Director in Office',
    [LegacyDocumentType.ShareCertificateStampPaper]:
      'Share Certificate Stamp Paper',
    [LegacyDocumentType.ShareCertificateStampPaperSigned]:
      'Share Certificate Stamp Paper Signed',
    [LegacyDocumentType.UnsignedShareCertificateStampPaper]:
      'Unsigned Share Certificate Stamp Paper',
    [LegacyDocumentType.NameReservation]: 'Name Reservation',
    [LegacyDocumentType.InitialBoardApproval]: 'Initial Board Approval',
    [LegacyDocumentType.BillForRegisteredAddressInIndia]:
      'Bill for Registered Address in India',
    [LegacyDocumentType.CP575]: 'CP575',
    [LegacyDocumentType.BOIFilingAcknowledgement]: 'BOI Filing Acknowledgement',
    [LegacyDocumentType.IndLLPIncorporationDocument]:
      'India LLP Incorporation Document',
    [LegacyDocumentType.SignedIndLLPIncorporationDocument]:
      'Signed India LLP Incorporation Document',
    [LegacyDocumentType.UnsignedIndLLPIncorporationDocument]:
      'Unsigned India LLP Incorporation Document',
    [LegacyDocumentType.UnsignedShareCertificate]: 'Unsigned Share Certificate',
    [LegacyDocumentType.ADTForm]: 'ADT Form signed by the client',
    [LegacyDocumentType.UnsignedADTForm]: 'ADT Form not signed by client',
    [LegacyDocumentType.CACertificate]: 'CA Certificate',
    [LegacyDocumentType.DIR12AndChallan]: 'DIR 12 and Challan',
    [LegacyDocumentType.UnsignedLLPDeed]: 'LLP Deed not signed by client',
    [LegacyDocumentType.ClientCourierReceipt]: 'Client Courier Receipt',
    [LegacyDocumentType.AuditorCourierReceipt]: 'Auditor Courier Receipt',
    [LegacyDocumentType.UIN]: 'UIN',
    // 1099 Misc
    [LegacyDocumentType.Form1099MiscExcelFiling]: 'Form 1099-MISC Excel Filing',
    [LegacyDocumentType.Form1099MiscExcelErrors]: 'Form 1099-MISC Excel Errors',
    [LegacyDocumentType.Form1099MiscExcelFilingCorrected]:
      'Form 1099-MISC Excel Filing Corrected',
    [LegacyDocumentType.Form1099PDFZipFiling]: 'Form 1099-MISC PDF Zip Filing',
    [LegacyDocumentType.Form1099PDFZipFilingForStorage]:
      'Form 1099-MISC PDF Zip Filing for Storage',
    [LegacyDocumentType.Form1099MiscExcelFilingCopy]:
      'Form 1099-MISC Excel Filing Copy',
    [LegacyDocumentType.Form1099ZipAcknowledgement]:
      'Form 1099-MISC Zip Filing Acknowledgement',
    // Document Generation
    [LegacyDocumentType.FeasibilityReport]: 'Feasibility Report',
    [LegacyDocumentType.ForeignPartyLetter]: 'Foreign Party Letter',
    [LegacyDocumentType.LiabilityDeclaration]: 'Liability Declaration',
    [LegacyDocumentType.NewODI]: 'New ODI',
    [LegacyDocumentType.UndertakingForODI]: 'Undertaking For ODI',
    [LegacyDocumentType.RemittanceForm]: 'Remittance Form',
    [LegacyDocumentType.FEMADeclaration]: 'FEMADeclaration',
    [LegacyDocumentType.IntercompanyAgreement]: 'Intercompany Agreement',
    [LegacyDocumentType.LocalFile]: 'Local File',
    [LegacyDocumentType.BenchmarkingStudy]: 'Benchmarking Study',
    [LegacyDocumentType.GuidanceMemo]: 'Guidance Memo',
    [LegacyDocumentType.CRLLetter]: 'CRLLetter',
    [LegacyDocumentType.BRInvestmentForm]: 'BRInvestmentForm',
    [LegacyDocumentType.FormFC]: 'FormFC',
    [LegacyDocumentType.IEDeclaration]: 'IEDeclaration',
    [LegacyDocumentType.FLADeclaration]: 'FLADeclaration',
    [LegacyDocumentType.ClarificationLetter]: 'ClarificationLetter',
    [LegacyDocumentType.VoterId]: 'Voter ID',
    [LegacyDocumentType.Passport]: 'Passport',
    [LegacyDocumentType.DrivingLicense]: 'Driving License',
    [LegacyDocumentType.PassportSizePhoto]: 'Passport Size Photo',
    [LegacyDocumentType.SpecimenSignature]: 'Specimen Signature',
    [LegacyDocumentType.Visa]: 'Visa',

    // UAE Documents
    [LegacyDocumentType.EmiratesId]: 'Emirates Id',
    [LegacyDocumentType.TradeLicenceCertificate]: 'Trade Licence Certificate',

    [LegacyDocumentType.UniqueTaxpayerReferenceCertificate]:
      'Unique Taxpayer Reference Certificate',
    [LegacyDocumentType.VATRegistrationCertificate]:
      'VAT Registration Certificate',
    [LegacyDocumentType.PAYELetter]: 'PAYE Letter',
    [LegacyDocumentType.EmployerCPFAccountActivationLetter]:
      'Employer CPF Account Activation Letter',
    [LegacyDocumentType.TRNLetter]: 'TRN Letter',
    [LegacyDocumentType.AELicenseCertificate]: 'AE License Certificate',
    [LegacyDocumentType.LicenseCertificate]: 'License Certificate',
    [LegacyDocumentType.EmployerEstablishmentCard]:
      'Employer Establishment Card',

    // Canada (ontario) Documents
    [LegacyDocumentType.CompanyKeyInformation]: 'Company Key Information',
    [LegacyDocumentType.ShareholderResolution]: 'Shareholder Resolution',
    [LegacyDocumentType.NoticeOfIssuanceOfUncertifiedShares]:
      'Notice of Issuance of Uncertified Shares',
    [LegacyDocumentType.DirectorsConsentAndAcknowledgement]:
      'Directors Consent and Acknowledgement',
    [LegacyDocumentType.FirstResolutionOfShareholders]:
      'First Resolution of Shareholders',
    [LegacyDocumentType.InitialReturn]: 'Initial Return',
    [LegacyDocumentType.NoticeOfShareTransfer]: 'Notice of Share Transfer',
    [LegacyDocumentType.ShareSubscriptionAgreement]:
      'Share Subscription Agreement',
    [LegacyDocumentType.CRABNConfirmation]: 'CRABN Confirmation',
    [LegacyDocumentType.PFRegistrationCertificate]:
      'PF Registration Certificate',
    [LegacyDocumentType.ESICRegistrationCertificate]:
      'ESIC Registration Certificate',
    [LegacyDocumentType.IECCertificate]: 'IEC Certificate',
    [LegacyDocumentType.UTRLetter]: 'UTR Letter',
    [LegacyDocumentType.SUIConfirmationLetter]: 'SUI Confirmation Letter',
    [LegacyDocumentType.WitholdingTaxConfirmationLetter]:
      'Witholding Tax Confirmation Letter',
    [LegacyDocumentType.CertificateOfAuthority]: 'Certificate of Authority',
    [LegacyDocumentType.TaxRegistrationCertificate]:
      'Tax Registration Certificate',
    [LegacyDocumentType.PAYERegistrationCertificate]:
      'PAYE Registration Certificate',
    [LegacyDocumentType.HMRCUTRLetter]: 'HMRC UTR Letter',
    [LegacyDocumentType.ShareTransferAgreement]: 'Share Transfer Agreement',
    [LegacyDocumentType.CompanyProfile]: 'Company Profile',
    [LegacyDocumentType.BankWireInstructions]: 'Bank Wire Instructions',
    [LegacyDocumentType.CompanyConstitution]: 'Company Constitution',
    [LegacyDocumentType.DirectorsConsentandAcknowledgement]:
      "Director's Consent and Acknowledgement",

    [LegacyDocumentType.NotarialDeedOfIncorporation]:
      'Notarial Deed of Incorporation',
    [LegacyDocumentType.Gesellschaftsvertrag]:
      'Articles of Association (Gesellschaftsvertrag)',
    [LegacyDocumentType.Handelsregisterauszug]:
      'Commercial Register Extract (Handelsregisterauszug)',
    [LegacyDocumentType.ShareholderList]: 'Shareholder List',

    [LegacyDocumentType.ExtraitKbis]: 'Extrait Kbis',
    [LegacyDocumentType.ShareholdersAgreement]: "Shareholders' Agreement",

    [LegacyDocumentType.URSSAFAffiliationLetter]: 'URSSAF Affiliation Letter',
    [LegacyDocumentType.BetriebsnummerAllocationLetter]:
      'Betriebsnummer Allocation Letter',
    [LegacyDocumentType.SteuernummerNotice]: 'Steuernummer Allocation Notice',

    [LegacyDocumentType.PAYGRegistrationConfirmation]:
      'PAYG Registration Confirmation',
    [LegacyDocumentType.TFNAllocationLetter]: 'TFN Allocation Letter',
    [LegacyDocumentType.ABNRegistrationRecord]: 'ABN Registration Record',

    // BC-specific documents
    [LegacyDocumentType.FirstResolutionOfDirectors]:
      'First Resolution of Directors',
    [LegacyDocumentType.ShareholdersResolutionDispensingWithAuditor]:
      "Shareholders' Resolution Dispensing with Auditor",
    [LegacyDocumentType.ArticlesOfIncorporation]: 'Articles of Incorporation',
    [LegacyDocumentType.RegistrationStatement]: 'Registration Statement',
    [LegacyDocumentType.ScheduleToArticles]: 'Schedule to Articles',
    [LegacyDocumentType.BusinessNumberIssuanceLetter]:
      'Business Number Issuance Letter',

    // New Zealand Documents
    [LegacyDocumentType.ShareholderConsentForm]: 'Shareholder Consent Form',
    [LegacyDocumentType.AnnualReturnFilingConfirmation]:
      'Annual Return Filing Confirmation',
    [LegacyDocumentType.LimitedPartnershipAgreement]:
      'Limited Partnership Agreement',
    [LegacyDocumentType.CertificateOfRegistration]: 'Certificate of Registration',
    [LegacyDocumentType.EstablishingLegislationOrOrder]:
      'Establishing Legislation or Order',
    [LegacyDocumentType.CoopRegistrationApplication]:
      'Co-operative Registration Application',
    [LegacyDocumentType.DirectorStatutoryDeclaration]:
      'Director Statutory Declaration',
    [LegacyDocumentType.IRDNumberNotice]: 'IRD Number Notice',
    [LegacyDocumentType.GSTRegistrationConfirmation]:
      'GST Registration Confirmation',
    [LegacyDocumentType.NZBNRegisterRecord]: 'NZBN Register Record',

    // Philippines Documents
    [LegacyDocumentType.HeadOfficeRegistrationDocument]:
      'Head Office Registration Document',
    [LegacyDocumentType.LicenseToDoBusiness]: 'License to Do Business',
    [LegacyDocumentType.AuditedFinancialStatements]:
      'Audited Financial Statements',
    [LegacyDocumentType.GeneralInformationSheet]:
      'General Information Sheet (GIS)',
    [LegacyDocumentType.ProofOfRegisteredAddress]: 'Proof of Registered Address',
    [LegacyDocumentType.CorporateRegisterExtract]: 'Corporate Register Extract',
    [LegacyDocumentType.EmployerRegistrationLetter]:
      'Employer Registration Letter',
    [LegacyDocumentType.BarangayClearance]: 'Barangay Clearance',
    [LegacyDocumentType.BusinessPermit]: "Mayor's / Business Permit",
    [LegacyDocumentType.VATCertificate]: 'VAT Certificate',
    [LegacyDocumentType.ArticlesOfPartnership]: 'Articles of Partnership',
    [LegacyDocumentType.CertificateOfRecording]: 'Certificate of Recording',

    // Switzerland Documents
    [LegacyDocumentType.Anlagereglement]: 'Fund Regulations (Anlagereglement)',
    [LegacyDocumentType.AnnahmeerklaerungAufsichtsstelle]:
      'Acceptance Declaration — Supervisory Body',
    [LegacyDocumentType.AnnahmeerklaerungGeschaeftsfuehrer]:
      'Acceptance Declaration — Managing Director',
    [LegacyDocumentType.AnnahmeerklaerungOrgane]:
      'Acceptance Declaration — Organs',
    [LegacyDocumentType.AnnahmeerklaerungPruefgesellschaft]:
      'Acceptance Declaration — Auditing Company',
    [LegacyDocumentType.AnnahmeerklaerungRevisionsstelle]:
      'Acceptance Declaration — Auditor',
    [LegacyDocumentType.AnnahmeerklaerungStiftungsrat]:
      'Acceptance Declaration — Foundation Board',
    [LegacyDocumentType.AnnahmeerklaerungVR]:
      'Acceptance Declaration — Board of Directors (VR)',
    [LegacyDocumentType.AnnahmeerklaerungVerwaltung]:
      'Acceptance Declaration — Administration',
    [LegacyDocumentType.AnnahmeerklaerungVorstand]:
      'Acceptance Declaration — Executive Board',
    [LegacyDocumentType.AnnualFinancialStatements]:
      'Annual Financial Statements',
    [LegacyDocumentType.AuditReport]: 'Audit Report',
    [LegacyDocumentType.AufsichtsbehoerdenVerfuegung]:
      'Supervisory Authority Order',
    [LegacyDocumentType.AusgleichskasseAffiliationConfirmation]:
      'AHV Compensation Fund Affiliation Confirmation',
    [LegacyDocumentType.BVGAffiliationAgreement]:
      'BVG Pension Fund Affiliation Agreement',
    [LegacyDocumentType.BankbescheinigungKapital]: 'Bank Capital Confirmation',
    [LegacyDocumentType.CantonalTaxAssessment]: 'Cantonal Tax Assessment',
    [LegacyDocumentType.CommercialRegisterExtract]:
      'Commercial Register Extract',
    [LegacyDocumentType.DomizilErklaerung]: 'Domicile Declaration',
    [LegacyDocumentType.ErnennungOrgane]: 'Appointment of Organs',
    [LegacyDocumentType.ErnennungStiftungsorgan]:
      'Appointment of Foundation Organ',
    [LegacyDocumentType.Errichtungsbeschluss]: 'Formation Resolution',
    [LegacyDocumentType.ErrichtungsbeschlussZN]:
      'Branch Formation Resolution',
    [LegacyDocumentType.FINMABewilligung]: 'FINMA Authorization',
    [LegacyDocumentType.FINMABewilligungFondsleitung]:
      'FINMA Authorization — Fund Management',
    [LegacyDocumentType.FINMAGenehmigungFondsvertrag]:
      'FINMA Approval — Fund Contract',
    [LegacyDocumentType.GenossenschafterVerzeichnis]:
      'Cooperative Members List',
    [LegacyDocumentType.Gruendungsbericht]: 'Formation Report',
    [LegacyDocumentType.HRAuszugHauptsitz]:
      'Commercial Register Extract — Head Office',
    [LegacyDocumentType.HRegAnmeldung]: 'Commercial Register Filing',
    [LegacyDocumentType.Kollektivanlagevertrag]:
      'Collective Investment Contract',
    [LegacyDocumentType.KonstituierungsprotokollVR]:
      'Board of Directors Constitution Minutes',
    [LegacyDocumentType.KonstituierungsprotokollVerwaltung]:
      'Administration Constitution Minutes',
    [LegacyDocumentType.Mitgliederverzeichnis]: 'Members List',
    [LegacyDocumentType.OeffentlichRechtlicheRechtsgrundlage]:
      'Public Law Basis',
    [LegacyDocumentType.OeffentlicheUrkundeErrichtung]:
      'Public Formation Deed',
    [LegacyDocumentType.PruefungsbestaetigungGruendung]:
      'Audit Confirmation — Formation',
    [LegacyDocumentType.SacheinlageVertrag]: 'Contribution-in-Kind Agreement',
    [LegacyDocumentType.Statuten]: 'Articles of Association (Statuten)',
    [LegacyDocumentType.StatutenGenossenschaft]:
      'Cooperative Articles of Association',
    [LegacyDocumentType.StatutenHauptsitz]:
      'Head Office Articles of Association',
    [LegacyDocumentType.Stiftungsurkunde]: 'Foundation Deed',
    [LegacyDocumentType.UIDConfirmation]:
      'Swiss Enterprise Identification Number (UID) Confirmation',
    [LegacyDocumentType.UVGInsuranceConfirmation]:
      'UVG Accident Insurance Confirmation',
    [LegacyDocumentType.VereinsstatutenUnterzeichnet]:
      'Signed Association Articles',
    [LegacyDocumentType.VereinsversammlungProtokoll]:
      'Association General Meeting Minutes',
    [LegacyDocumentType.VertretungsbeschlussZN]:
      'Branch Representation Resolution',

    // British Virgin Islands Documents
    [LegacyDocumentType.AnnualFinancialReturn]: 'Annual Financial Return',
    [LegacyDocumentType.AnnualGovernmentFeeReceipt]:
      'Annual Government Fee Receipt',
    [LegacyDocumentType.BeneficialOwnershipFiling]:
      'Beneficial Ownership Filing (BOSSs)',
    [LegacyDocumentType.CertifiedParentConstitutionalDocuments]:
      'Certified Parent Constitutional Documents',
    [LegacyDocumentType.EconomicSubstanceNotification]:
      'Economic Substance Notification',
    [LegacyDocumentType.EconomicSubstanceReturn]:
      'Economic Substance Return',
    [LegacyDocumentType.ForeignCompanyRegistrationCertificate]:
      'Foreign Company Registration Certificate',
    [LegacyDocumentType.MemorandumAndArticlesOfAssociation]:
      'Memorandum and Articles of Association',
    [LegacyDocumentType.MutualFundApproval]: 'Mutual Fund Approval (FSC)',
    [LegacyDocumentType.PartnershipAgreement]: 'Partnership Agreement',
    [LegacyDocumentType.RegisterOfDirectors]: 'Register of Directors',
    [LegacyDocumentType.RegisterOfMembers]: 'Register of Members',
    [LegacyDocumentType.RegisteredAgentAppointment]:
      'Registered Agent Appointment',
    [LegacyDocumentType.RegisteredOfficeNotice]: 'Registered Office Notice',
    // Entity-management backfill country packs
    [LegacyDocumentType.UpdatedStatutesCertificate]:
      'Updated Statutes Certificate',
    [LegacyDocumentType.CompanySealCertificate]: 'Company Seal Certificate',
    [LegacyDocumentType.TaxOfficeEstablishmentNotification]:
      'Tax Office Establishment Notification',
    [LegacyDocumentType.CommunityInterestStatement]:
      'Community Interest Statement',
    [LegacyDocumentType.OfficialGazettePublication]:
      'Official Gazette Publication',
    // Fiji
    [LegacyDocumentType.FijiBusinessProfile]: 'Business Profile',
    [LegacyDocumentType.CertificateOfRegistrationOfCompany]:
      'Certificate of Registration of Company',
    [LegacyDocumentType.CertificateOfRegistrationOfBusinessName]:
      'Certificate of Registration of a Business Name',
    [LegacyDocumentType.LimitedNameDispensationLicence]:
      'Licence to Dispense with Limited in the Name of the Company',
    [LegacyDocumentType.TINLetter]: 'TIN Letter',
    [LegacyDocumentType.VATRegistrationConfirmationLetter]:
      'VAT Registration Confirmation Letter',
    [LegacyDocumentType.FNPFEmployerRegistrationRecord]:
      'FNPF Employer Registration Record',
    // Country packs (dedicated document types)
    [LegacyDocumentType.AcraBusinessProfile]: 'Business Profile',
    [LegacyDocumentType.AhuRegistrationRecord]:
      'AHU registration/profile record',
    [LegacyDocumentType.BeneficialOwnerDeclaration]:
      'Beneficial Owner Declaration',
    [LegacyDocumentType.BpsRegistrationRecord]:
      'BPS Registration Record',
    [LegacyDocumentType.CedulaRutElectronica]: 'Cédula RUT electrónica',
    [LegacyDocumentType.CertidaoPermanente]:
      'Business Register Extract',
    [LegacyDocumentType.CertificadoDeVigencia]:
      'Certificado de Vigencia',
    [LegacyDocumentType.CertificateOfBusinessRegistration]:
      'Certificate of Business Registration',
    [LegacyDocumentType.CertificateOfEstablishment]:
      'Certificate of Establishment',
    [LegacyDocumentType.CertificateOfExistenceAndLegalRepresentation]:
      'Certificate of Existence and Legal Representation',
    [LegacyDocumentType.CertificateOfRegisteredMatters]:
      'Certificate of Registered Matters',
    [LegacyDocumentType.CertificateOnRegisteredInformation]:
      'Certificate on Registered Information',
    [LegacyDocumentType.CertificatoCodiceFiscale]:
      'Certificato di Attribuzione del Codice Fiscale',
    [LegacyDocumentType.ChileanCommercialRegistryEntry]:
      'Commercial Registry Entry',
    [LegacyDocumentType.CipcRegistrationCertificate]:
      'Registration Certificate',
    [LegacyDocumentType.CnpjRegistrationCertificate]:
      'CNPJ Registration Certificate',
    [LegacyDocumentType.ColombianFormationDocument]:
      'Formation Document',
    [LegacyDocumentType.CompanyInformationRecord]:
      'Company Information Record',
    [LegacyDocumentType.ConstanciaDeInscripcion]:
      'Constancia de Inscripción',
    [LegacyDocumentType.ConstanciaDeSituacionFiscal]:
      'Constancia de Situacion Fiscal',
    [LegacyDocumentType.ConstitutiveInstrument]:
      'Constitutive Instrument',
    [LegacyDocumentType.ContratoSocial]: 'Contrato Social',
    [LegacyDocumentType.CooperativeApplicationAndConstitution]:
      'Co-operative Registration Application and Constitution',
    [LegacyDocumentType.DeedOfIncorporation]:
      'Deed of Incorporation / Articles of Association',
    [LegacyDocumentType.EFirmaCertificate]: 'e.firma Certificate',
    [LegacyDocumentType.EstatutoSocial]: 'Estatuto Social',
    [LegacyDocumentType.FgtsESocialEmployerRegistration]:
      'FGTS/eSocial Employer Registration Confirmation',
    [LegacyDocumentType.FormationInstrument]: 'Formation Instrument',
    [LegacyDocumentType.FoundationInstrument]: 'Foundation Instrument',
    [LegacyDocumentType.FoundingStatement]: 'Founding Statement',
    [LegacyDocumentType.FrenchTaxRegistrationCertificate]:
      'Tax Registration Certificate',
    [LegacyDocumentType.FscRegistryEntry]: 'FSC Registry Entry',
    [LegacyDocumentType.HmrcVatCertificate]: 'VAT Certificate',
    [LegacyDocumentType.ImssEmployerRegistration]:
      'IMSS Employer Registration Confirmation',
    [LegacyDocumentType.JuntaComercialExtract]:
      'Commercial Registry Extract',
    [LegacyDocumentType.KvkExtract]: 'KVK Business Register Extract',
    [LegacyDocumentType.MemorandumOfIncorporation]:
      'Memorandum of Incorporation',
    [LegacyDocumentType.MersisRecord]: 'MERSIS Record',
    [LegacyDocumentType.MojRegistryEntry]: 'MOJ Registry Entry',
    [LegacyDocumentType.NationalCommerceRegistryCertificate]:
      'National Commerce Registry Information Certificate',
    [LegacyDocumentType.NibRecord]: 'Business Identification Number',
    [LegacyDocumentType.NoticeOfSuccessfulIncorporation]:
      'Notice of Successful Incorporation',
    [LegacyDocumentType.NoticeOfSuccessfulRegistration]:
      'Notice of Successful Registration',
    [LegacyDocumentType.NotificationOfCorporateNumber]:
      'Notification of Corporate Number',
    [LegacyDocumentType.PayrollTaxRegistrationConfirmation]:
      'Payroll Tax Registration Confirmation',
    [LegacyDocumentType.PublicDeedExtract]: 'Public Deed Extract',
    [LegacyDocumentType.PublicDeedOfIncorporation]:
      'Public Deed of Incorporation',
    [LegacyDocumentType.PublicRegistryEntry]: 'Public Registry Entry',
    [LegacyDocumentType.QualifiedInvoiceIssuerRegistrationNotice]:
      'Qualified Invoice Issuer Registration Notice',
    [LegacyDocumentType.RegistroUnicoTributario]:
      'Registro Único Tributario',
    [LegacyDocumentType.RmdTaxRegistrationCertificate]:
      'Tax Registration Certificate',
    [LegacyDocumentType.RpcExtract]: 'RPC Extract',
    [LegacyDocumentType.RutRegistrationCertificate]:
      'RUT Registration Certificate',
    [LegacyDocumentType.SarsTaxRegistrationRecord]:
      'SARS Tax Registration Record',
    [LegacyDocumentType.SasDigitalRegistrationCertificate]:
      'SAS Digital Registration Certificate',
    [LegacyDocumentType.SaudiCommercialRegistration]:
      'Commercial Registration',
    [LegacyDocumentType.SocialLaborInsuranceRegistrationRecords]:
      'Employer Registration Records (Social & Labor Insurance)',
    [LegacyDocumentType.SocietyRules]: 'Society Rules',
    [LegacyDocumentType.SpaStatutes]: 'SpA Statutes',
    [LegacyDocumentType.SpedReceipt]: 'SPED ECD/ECF Receipt',
    [LegacyDocumentType.TinRegistrationRecord]:
      'TIN Registration Record',
    [LegacyDocumentType.UboRegisterExtract]: 'UBO Register Extract',
    [LegacyDocumentType.UstIdNrConfirmation]:
      'VAT Registration Certificate',
    [LegacyDocumentType.VatRegistrationConfirmation]:
      'VAT Registration Confirmation',
    [LegacyDocumentType.VisuraCamerale]: 'Company Report',
  };

  return record[t];
};

export const documentDescription = (t: LegacyDocumentType | undefined) => {
  switch (t) {
    case undefined:
      return '';
    case LegacyDocumentType.GST_REGISTRATION_FORM:
      return 'Form used to register for Goods and Services Tax (GST) with the Indian government, required for businesses exceeding the registration threshold.';
    case LegacyDocumentType.SalesTaxInformation:
      return 'Information related to indirect taxes such as VAT or Sales Tax depending on the jurisdiction, used to determine nexus and filing obligations.';
    case LegacyDocumentType.Form940:
      return 'Annual federal unemployment (FUTA) tax return filed by employers to report and pay unemployment taxes.';
    case LegacyDocumentType.Form941:
      return 'Quarterly federal tax return filed by employers to report income taxes, Social Security tax, or Medicare tax withheld from employees’ paychecks.';
    case LegacyDocumentType.Form9:
      return 'Form filed by LLPs in India detailing their statement of accounts and solvency, mandatory under the LLP Act.';
    case LegacyDocumentType.SubscribersSheet:
      return 'Document listing individuals or entities subscribing to shares during company incorporation.';
    case LegacyDocumentType.INC20A:
      return 'Declaration of commencement of business filed by companies with share capital after receiving the certificate of incorporation.';
    case LegacyDocumentType.LLPDeed:
      return 'Legal agreement among LLP partners defining roles, responsibilities, and share in the business.';
    case LegacyDocumentType.CorporatePAN:
      return 'Permanent Account Number (PAN) assigned to a company for tax identification and tracking of financial transactions.';
    case LegacyDocumentType.DigitalSignatureCertificate:
      return 'Digital equivalent of a physical signature used for filing documents with the Ministry of Corporate Affairs.';
    case LegacyDocumentType.TAN:
      return 'Tax Deduction and Collection Account Number, required for deducting or collecting tax at source.';
    case LegacyDocumentType.RentalAgreement:
      return 'Legally binding contract between landlord and tenant outlining rental terms and property use.';
    case LegacyDocumentType.BillForRegisteredAddress:
      return 'Utility or official bill verifying the address used as the business’s registered office.';
    case LegacyDocumentType.formationDocument:
      return 'State-stamped documents like Articles of Incorporation or Certificate of Formation submitted to legally register a business.';
    case LegacyDocumentType.Custom:
      return 'IRS form used to apply for an Employer Identification Number (EIN) for a business entity.';
    case LegacyDocumentType.SS4:
      return 'IRS form used to apply for an Employer Identification Number (EIN) for a business.';
    case LegacyDocumentType.AadharCard:
      return 'Unique 12-digit identity number issued by UIDAI to Indian residents, used for identity verification.';
    case LegacyDocumentType.PanCard:
      return 'Identification card issued by the Indian Income Tax Department containing the PAN number.';
    case LegacyDocumentType.CertificateOfIncorporation:
      return 'Official legal document issued upon company registration that proves its legal existence.';
    case LegacyDocumentType.CertificateOfAmendment:
      return 'Official filing that records a change to the company charter, such as a name change or a change in authorized shares.';
    case LegacyDocumentType.MemorandumOfAssociation:
      return "Legal document outlining a company's objectives and powers, part of incorporation paperwork.";
    case LegacyDocumentType.InitialBondApprovalCall:
      return "Document showing meeting between the company's founding team and the board of directors to obtain the board's approval for the company's formation and initial activities.";
    case LegacyDocumentType.SharePurchaseAndSaleAgreement:
      return 'Legally binding document that sets out the terms and conditions for the purchase and sale of shares in a company.';
    case LegacyDocumentType.BoardConsent:
      return 'Board Consent(s)';
    case LegacyDocumentType.ShareCertificate:
      return "Legal proof of ownership of the corporation's shares.";
    case LegacyDocumentType.YearlyFinancials:
      return 'Annual financial statements such balance sheet, income statement, and cash flow statement.';
    case LegacyDocumentType.BankStatements:
      return 'Used by businesses for bookkeeping, tax preparation, and financial analysis. They are crucial for managing cash flow and financial planning.';
    case LegacyDocumentType.CardStatements:
      return 'Card Statements';
    case LegacyDocumentType.AnnualAuditPreviousYear:
      return 'Annual Audit Previous Year';
    case LegacyDocumentType.AddressProof:
      return 'Address Verification Proof is required.';
    case LegacyDocumentType.ArticlesOfAssociation:
      return 'Internal rules governing the operation and management of a company.';
    case LegacyDocumentType.Bylaws:
      return 'Internal rules adopted by a corporation to govern its internal management.';
    case LegacyDocumentType.EIN:
      return 'Employer Identification Number issued by the IRS for business tax reporting.';
    case LegacyDocumentType.CapTable:
      return 'Document that shows the ownership structure of a company, detailing the percentages of ownership of each shareholder and the types of securities they hold.';
    case LegacyDocumentType.StockPlansAndOptionAgreement:
      return 'Stock Plans and Option Agreement(s)';
    case LegacyDocumentType.Invoices:
      return 'Proof that a sale has been made.';
    case LegacyDocumentType.NonDisclosureAgreement:
      return 'Confidentiality and nondisclosure agreements binding the Company.';
    case LegacyDocumentType.IncomeStatement:
      return 'Income Statement';
    case LegacyDocumentType.CashFlowStatement:
      return 'Cash Flow Statement';
    case LegacyDocumentType.CashFlowStatements:
      return 'Cash Flow Statement(s)';
    case LegacyDocumentType.CommencementOfBusiness:
      return 'Commencement of Business';
    case LegacyDocumentType.ProfitLossStatements:
      return 'Profit Loss Statement(s)';
    case LegacyDocumentType.BalanceSheet:
      return 'Balance Sheet';
    case LegacyDocumentType.ExpenseDocuments:
      return 'Expense Documents';
    case LegacyDocumentType.BillDocuments:
      return 'Bill Documents';
    case LegacyDocumentType.AnnualProfitLossStatement:
      return 'Annual Profit Loss Statement';
    case LegacyDocumentType.GovernmentId:
      return 'Government Id Document(s)';
    case LegacyDocumentType.Other:
      return 'Other';
    case LegacyDocumentType.Unknown:
      return 'Other';
    case LegacyDocumentType.Form5472Acknowledgement:
      return 'Proof that Form 5472 has been completed';
    case LegacyDocumentType.Form1099Acknowledgement:
      return 'Proof that Form 1099 has been completed';
    case LegacyDocumentType.FBARAcknowledgement:
      return 'Proof that FBAR Filing has been completed';
    case LegacyDocumentType.GoodStandingCertificate:
      return 'Certificate issued by the state confirming a company’s legal status and compliance.';
    case LegacyDocumentType.LLCOperatingAgreement:
      return 'A document that outlines the governance and operational processes of an LLC.';
    case LegacyDocumentType.ActionBySoleIncorporator:
      return 'A document that appoints the first Board of Directors';
    case LegacyDocumentType.SAFE:
      return 'Simple Agreement for Future Equity; a contract that allows investors to convert investment into equity at a future date.';
    case LegacyDocumentType.ContractorAgreement:
      return 'Agreement between your entity and a contractor, specifying their position and compensation.';
    case LegacyDocumentType.PrivacyPolicy:
      return 'A legal statement that informs your users about how their personal information is collected.';
    case LegacyDocumentType.ComplianceAcknowledgement:
      return 'Proof that Compliance has been completed';
    case LegacyDocumentType.AntlerShareholdersRightsLetter:
      return '';
    case LegacyDocumentType.OperatingAgreement:
      return 'An operating agreement for a US LLC is a legal document outlining the ownership, management structure, and operating procedures of the company.';
    case LegacyDocumentType.MonthlyMISReport:
      return "A concise summary of an organization's financial performance and key metrics over a month.";
    case LegacyDocumentType.UnauditedFinancialStatements:
      return "Provisional financial reports not subjected to independent scrutiny, providing preliminary insights into a company's financial health.";
    case LegacyDocumentType.SpiceA:
      return 'Form used to reserve a name for a Private Limited Company during incorporation.';
    case LegacyDocumentType.SpiceB:
      return 'Form used for incorporation of a company, including submission of documents, application for DIN, PAN, and TAN.';
    case LegacyDocumentType.AgileForm:
      return 'Form for GSTIN, ESIC, EPFO, and bank account opening as part of company incorporation.';
    case LegacyDocumentType.RunLLP:
      return 'Form used to reserve a name for a Limited Liability Partnership.';
    case LegacyDocumentType.Fillip:
      return 'Form used for incorporation of LLP, including partner details and supporting documents.';
    case LegacyDocumentType.EINScreenshot:
      return 'This screenshot serves as proof of the application for an Employer Identification Number (EIN) for the company.';
    case LegacyDocumentType.BoardResolution:
      return 'Official record of decisions made by a company’s board of directors.';
    case LegacyDocumentType.InitialBoardApproval:
      return "Document showing meeting between the company's founding team and the board of directors to obtain the board's approval for the company's formation and initial activities.";
    case LegacyDocumentType.BillForRegisteredAddressInIndia:
      return 'Bill for Registered Address';
    case LegacyDocumentType.BOIFilingAcknowledgement:
      return 'Proof that Beneficial Ownership Information (BOI) has been filed with FinCEN.';
    case LegacyDocumentType.ShareholderResolution:
      return 'Document containing decisions made by shareholders regarding corporate matters and governance issues.';
    case LegacyDocumentType.NoticeOfIssuanceOfUncertifiedShares:
      return 'Official notice documenting the issuance of shares in electronic or book-entry form without physical certificates.';
    case LegacyDocumentType.DirectorsConsentAndAcknowledgement:
      return 'Document where directors formally consent to their appointment and acknowledge their duties and responsibilities.';
    case LegacyDocumentType.FirstResolutionOfShareholders:
      return 'Initial resolution passed by shareholders typically addressing foundational corporate matters and governance structure.';
    case LegacyDocumentType.InitialReturn:
      return 'First filing with corporate registry providing initial information about the corporation and its officers.';
    case LegacyDocumentType.NoticeOfShareTransfer:
      return 'Official notification documenting the transfer of shares from one party to another.';
    case LegacyDocumentType.ShareSubscriptionAgreement:
      return 'Agreement between a company and investor outlining the terms for purchasing newly issued shares.';
    case LegacyDocumentType.ShareTransferAgreement:
      return 'Legal agreement governing the transfer of existing shares between parties, including terms and conditions of the transfer.';
    case LegacyDocumentType.UpdatedStatutesCertificate:
      return 'Certificate of the company\'s current consolidated statutes issued by the digital business registry after amendments.';
    case LegacyDocumentType.CompanySealCertificate:
      return 'Certificate issued by the registry verifying the company\'s registered corporate seal, commonly required for contracts and banking in Japan.';
    case LegacyDocumentType.TaxOfficeEstablishmentNotification:
      return 'Notification of corporate establishment filed with the national and local tax offices after incorporation.';
    case LegacyDocumentType.CommunityInterestStatement:
      return 'Statement filed by a Community Interest Company describing how its activities benefit the community.';
    case LegacyDocumentType.OfficialGazettePublication:
      return 'Official gazette publication of the company\'s formation extract, required to complete incorporation in several jurisdictions.';
    case LegacyDocumentType.FijiBusinessProfile:
      return 'Business profile issued by the Fiji Registrar of Companies summarising the registered details of the company.';
    case LegacyDocumentType.CertificateOfRegistrationOfCompany:
      return 'Certificate issued by the Fiji Registrar of Companies confirming the company has been registered under the Companies Act.';
    case LegacyDocumentType.CertificateOfRegistrationOfBusinessName:
      return 'Certificate issued by the Fiji Registrar of Companies confirming registration of a trading or business name.';
    case LegacyDocumentType.LimitedNameDispensationLicence:
      return 'Licence permitting a Fijian company limited by guarantee to omit the word "Limited" from its name.';
    case LegacyDocumentType.TINLetter:
      return 'Letter issued by the Fiji Revenue and Customs Service confirming the taxpayer identification number.';
    case LegacyDocumentType.VATRegistrationConfirmationLetter:
      return 'Letter issued by the Fiji Revenue and Customs Service confirming VAT registration, commencement date and filing period.';
    case LegacyDocumentType.FNPFEmployerRegistrationRecord:
      return 'Record of employer registration with the Fiji National Provident Fund, including the employer reference number.';
    case LegacyDocumentType.AcraBusinessProfile:
      return 'Business profile issued by ACRA via Bizfile summarising the entity\'s registered particulars.';
    case LegacyDocumentType.NoticeOfSuccessfulIncorporation:
      return 'Notice issued by ACRA confirming successful incorporation of the company, stating the UEN.';
    case LegacyDocumentType.NoticeOfSuccessfulRegistration:
      return 'Notice issued by ACRA confirming successful registration of the partnership, stating the UEN.';
    case LegacyDocumentType.PublicDeedExtract:
      return 'Extract of the notarised public deed of incorporation, registered with the Commercial Registry.';
    case LegacyDocumentType.ChileanCommercialRegistryEntry:
      return 'Entry in the Registro de Comercio evidencing the company\'s registration with the Chilean Commercial Registry.';
    case LegacyDocumentType.CedulaRutElectronica:
      return 'Electronic RUT card issued by the Servicio de Impuestos Internos evidencing the tax identification number.';
    case LegacyDocumentType.CertificadoDeVigencia:
      return 'Good-standing certificate issued by the Chilean registry confirming the company remains validly constituted.';
    case LegacyDocumentType.SpaStatutes:
      return 'SpA statutes registered through Chile\'s Registro de Empresas y Sociedades digital registry.';
    case LegacyDocumentType.CompanyInformationRecord:
      return 'Company information record (registreringsbevis) issued by Bolagsverket showing the entity\'s registered details.';
    case LegacyDocumentType.ColombianFormationDocument:
      return 'Constitution document (public deed or private document) registered with the Colombian Chamber of Commerce.';
    case LegacyDocumentType.CertificateOfExistenceAndLegalRepresentation:
      return 'Certificate issued by the Chamber of Commerce confirming the existence of the company and its legal representatives.';
    case LegacyDocumentType.RegistroUnicoTributario:
      return 'Registro Único Tributario certificate issued by DIAN evidencing tax registration and the NIT.';
    case LegacyDocumentType.FormationInstrument:
      return 'Formation instrument (statute or social contract) filed with the Argentine public registry.';
    case LegacyDocumentType.PublicRegistryEntry:
      return 'Public registry entry evidencing the company\'s registration under Ley 19.550.';
    case LegacyDocumentType.ConstanciaDeInscripcion:
      return 'Constancia de Inscripción issued by ARCA evidencing the CUIT tax registration.';
    case LegacyDocumentType.ConstitutiveInstrument:
      return 'Constitutive instrument of the company registered with the National Commerce Registry.';
    case LegacyDocumentType.NationalCommerceRegistryCertificate:
      return 'Information certificate issued by the Uruguayan National Commerce Registry.';
    case LegacyDocumentType.RutRegistrationCertificate:
      return 'Certificate evidencing RUT tax registration with the Dirección General Impositiva.';
    case LegacyDocumentType.BpsRegistrationRecord:
      return 'Record of employer registration with the Banco de Previsión Social, including the BPS company number.';
    case LegacyDocumentType.SasDigitalRegistrationCertificate:
      return 'Digital registration certificate issued for a Uruguayan SAS constituted through the electronic path.';
    case LegacyDocumentType.CertificateOnRegisteredInformation:
      return 'Certificate on registered information (tōkibo tōhon) issued by the Legal Affairs Bureau evidencing the corporate registry entry.';
    case LegacyDocumentType.NotificationOfCorporateNumber:
      return 'Notification issued by the National Tax Agency designating the 13-digit Corporate Number.';
    case LegacyDocumentType.QualifiedInvoiceIssuerRegistrationNotice:
      return 'Registration notice issued by the National Tax Agency confirming qualified invoice issuer (T-Number) status.';
    case LegacyDocumentType.SocialLaborInsuranceRegistrationRecords:
      return 'Employer registration records for social insurance (Japan Pension Service) and labor insurance (Labour Standards Office / Hello Work).';
    case LegacyDocumentType.MemorandumOfIncorporation:
      return 'Memorandum of Incorporation setting out the company\'s governing rules, filed with the CIPC.';
    case LegacyDocumentType.CipcRegistrationCertificate:
      return 'Registration certificate (CoR 14.1) issued by the CIPC confirming company registration.';
    case LegacyDocumentType.FoundingStatement:
      return 'Founding statement (CK1) evidencing registration of a South African close corporation.';
    case LegacyDocumentType.CooperativeApplicationAndConstitution:
      return 'Registration application and constitution of a South African co-operative filed with the CIPC.';
    case LegacyDocumentType.SarsTaxRegistrationRecord:
      return 'Record evidencing income tax registration with the South African Revenue Service.';
    case LegacyDocumentType.FscRegistryEntry:
      return 'Registry entry issued by the Cook Islands Financial Supervisory Commission evidencing registration.';
    case LegacyDocumentType.MojRegistryEntry:
      return 'Registry entry issued by the Cook Islands Ministry of Justice evidencing incorporation.';
    case LegacyDocumentType.CertificateOfEstablishment:
      return 'Certificate of establishment issued by the Financial Supervisory Commission for a Cook Islands foundation.';
    case LegacyDocumentType.FoundationInstrument:
      return 'Foundation instrument setting out the foundation\'s purposes and governance, filed on establishment.';
    case LegacyDocumentType.SocietyRules:
      return 'Rules of the incorporated society filed with the Cook Islands Ministry of Justice.';
    case LegacyDocumentType.RmdTaxRegistrationCertificate:
      return 'Certificate evidencing tax registration with the Cook Islands Revenue Management Division.';
    case LegacyDocumentType.CertidaoPermanente:
      return 'Certidão Permanente — the permanent online extract of the company\'s commercial registry record.';
    case LegacyDocumentType.AhuRegistrationRecord:
      return 'Registration record issued by the Ministry of Law (AHU) evidencing legal-entity registration.';
    case LegacyDocumentType.NibRecord:
      return 'Business Identification Number (NIB) record issued through the OSS licensing system.';
    case LegacyDocumentType.CertificateOfRegisteredMatters:
      return 'Certificate of registered matters issued by the court registry evidencing the corporate registration.';
    case LegacyDocumentType.CertificateOfBusinessRegistration:
      return 'Certificate of business registration issued by the National Tax Service, stating the business registration number.';
    case LegacyDocumentType.SaudiCommercialRegistration:
      return 'Commercial Registration (CR) issued by the Ministry of Commerce, stating the unified national number.';
    case LegacyDocumentType.VisuraCamerale:
      return 'Visura camerale — the company report extracted from the Registro delle Imprese showing the entity\'s registered details.';
    case LegacyDocumentType.CertificatoCodiceFiscale:
      return 'Certificate issued by the Agenzia delle Entrate attributing the company\'s codice fiscale.';
    case LegacyDocumentType.MersisRecord:
      return 'MERSIS record evidencing trade registry registration, stating the 16-digit MERSIS number.';
    case LegacyDocumentType.KvkExtract:
      return 'KVK Business Register extract (uittreksel) showing the registered details of the entity.';
    case LegacyDocumentType.DeedOfIncorporation:
      return 'Notarial deed of incorporation containing the articles of association, executed before a Dutch civil-law notary.';
    case LegacyDocumentType.UboRegisterExtract:
      return 'Extract from the Dutch UBO register evidencing the registered ultimate beneficial owners.';
    case LegacyDocumentType.PayrollTaxRegistrationConfirmation:
      return 'Confirmation of payroll tax (loonheffingen) registration issued by the Belastingdienst.';
    case LegacyDocumentType.VatRegistrationConfirmation:
      return 'Confirmation of VAT registration issued by the Belastingdienst, stating the btw-id.';
    case LegacyDocumentType.RpcExtract:
      return 'Extract from the Public Registry of Commerce evidencing the registered commercial folio.';
    case LegacyDocumentType.ConstanciaDeSituacionFiscal:
      return 'Constancia de Situación Fiscal issued by the SAT evidencing the RFC and current tax status.';
    case LegacyDocumentType.ImssEmployerRegistration:
      return 'Employer registration confirmation issued by the IMSS, stating the employer registration number.';
    case LegacyDocumentType.PublicDeedOfIncorporation:
      return 'Notarised public deed of incorporation registered with the Public Registry of Commerce.';
    case LegacyDocumentType.EFirmaCertificate:
      return 'e.firma digital signature certificate issued by the SAT for electronic tax filings.';
    case LegacyDocumentType.JuntaComercialExtract:
      return 'Extract issued by the Junta Comercial evidencing the commercial registry record (NIRE).';
    case LegacyDocumentType.CnpjRegistrationCertificate:
      return 'Comprovante de Inscrição CNPJ issued by the Receita Federal evidencing tax registration.';
    case LegacyDocumentType.ContratoSocial:
      return 'Contrato Social — the articles of organisation of a Brazilian limitada, registered with the Junta Comercial.';
    case LegacyDocumentType.EstatutoSocial:
      return 'Estatuto Social — the bylaws of a Brazilian sociedade anônima, registered with the Junta Comercial.';
    case LegacyDocumentType.FgtsESocialEmployerRegistration:
      return 'Confirmation of employer registration with FGTS/eSocial for Brazilian payroll obligations.';
    case LegacyDocumentType.SpedReceipt:
      return 'Receipt evidencing SPED ECD/ECF digital bookkeeping and fiscal filings with the Receita Federal.';
    case LegacyDocumentType.UstIdNrConfirmation:
      return 'Confirmation of the VAT identification number (USt-IdNr) issued by the Bundeszentralamt für Steuern.';
    case LegacyDocumentType.FrenchTaxRegistrationCertificate:
      return 'Certificate evidencing French tax registration of the company (SIREN/SIRET-based).';
    case LegacyDocumentType.BeneficialOwnerDeclaration:
      return 'Declaration of beneficial owners (bénéficiaires effectifs) filed with the French registry.';
    case LegacyDocumentType.HmrcVatCertificate:
      return 'VAT registration certificate issued by HMRC, stating the VAT registration number and effective date.';
    case LegacyDocumentType.TinRegistrationRecord:
      return 'Record evidencing taxpayer identification number registration with the BVI Inland Revenue Department.';
    default:
      return `${t} Document`;
  }
};
